/* eslint-disable */

export default {
  init() {
    if ($("input#submitText").val() !== "") {
      $('input[type="submit"]').val($("input#submitText").val());
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateContact2.js